var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47976 3.31311C5.67502 3.11785 5.9916 3.11785 6.18687 3.31311L10.5202 7.64644C10.7155 7.84171 10.7155 8.15829 10.5202 8.35355L6.18687 12.6869C5.9916 12.8821 5.67502 12.8821 5.47976 12.6869C5.2845 12.4916 5.2845 12.175 5.47976 11.9798L9.45954 8L5.47976 4.02022C5.2845 3.82496 5.2845 3.50837 5.47976 3.31311Z",
    fill: "#007BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.7f307edb647df28d4438318bc2002c8e.svg";
export { ForwardRef as ReactComponent };